import { DeployPhase } from "./deploy-phase";

export class DeployPhaseListComparison {
  before: DeployPhase[];
  after: DeployPhase[];

  public constructor(before: DeployPhase[], after: DeployPhase[]) {
    this.before = before;
    this.after = after;
  }
}